import Header from './Header';
import Footer from './Footer';

export default function PageLayout({ children }) {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-white via-sky-50 to-sky-100 text-slate-900">
      <div className="min-h-screen w-full flex flex-col px-4 py-6 550:px-6">
        <div className="flex-1 w-full overflow-hidden rounded-3xl border border-slate-200 bg-white/70 backdrop-blur-xl shadow-2xl flex flex-col anim-fade-in">
          <Header />
          <div className="flex-1">
            {children}
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
